export default "__VITE_ASSET__UvNVTZ2a__"